<button [disabled]="disabled()" class="table-btn" (click)="openFollowUpModal()">Follow up</button>
